import StringHelper from './StringHelper';

class RouteHelper {

    static encodeRedirectData(pathName, params = {}) {
        const data = { pathName, params };
        return StringHelper.base64Encode(StringHelper.objectToString(data));
    }

    static decodeRedirectData(encoded) {
        try {
            const decoded = StringHelper.base64Decode(encoded);
            return JSON.parse(decoded);
        } catch {
            return null;
        }
    }

    static buildUrlFromRedirectData(data, defaultPath) {
        defaultPath = typeof defaultPath === "string" ? defaultPath : '/';
        if (!data || !data.pathName) return defaultPath;
        const params = data.params && typeof data.params === 'object' ? data.params : {};
        const query = new URLSearchParams(params).toString();
        return query ? `${data.pathName}?${query}` : data.pathName;
    }

    static buildQueryString(params = {}) {
        const searchParams = new URLSearchParams();
        Object.entries(params || {}).forEach(([key, value]) => {
            if (value === undefined || value === null) return;
            searchParams.set(key, value);
        });
        return searchParams.toString();
    }

    static buildLoginUrl(pathName, params = {}, extraParams = {}) {
        const encoded = RouteHelper.encodeRedirectData(pathName, params);
        const query = RouteHelper.buildQueryString(Object.assign({ r: encoded }, extraParams));
        return `/login?${query}`;
    }
}

export default RouteHelper;
